// Libraries
import { observable, transaction } from 'mobx';
import intl from 'react-intl-universal';
import Config from '../config';
import BigNumber from 'bignumber.js';
import {
    getDepositApy,
    getLendApy,
    getPrecision,
    getExchangeRate,
    getDeposit,
    getEarned,
    getDepositUsd,
    getBorrowBalanceNew,
    getBorrowBalanceNewUsd,
    getInterest,
    getBorrowLimit,
    getBorrowPercent,
    getTotalLendUsd,
    getParameterByName,
    getInterestOrEarnedUsd,
    reTry,
    getGainNewAndOld,
    getTransferringSoonAndInFreeze,
    getNetAPY
} from '../utils/helper';
import { tokenBalanceOf, getLatestBlockInfo, getBalanceInfo } from '../utils/blockchain';
import {
    getMarketData,
    getUserData,
    getVoteList,
    getUserDetail,
    getMintInfo,
    getTronbullish,
    getTronBull,
    getTimeNow
} from '../utils/backend';

const tempLength = 3

const tempProp = {
    "activeTime": 1624864492000,
    "againstVotes": "0",
    "cancelTime": null,
    "content": null,
    "endBlock": 16952171,
    "endTime": 1624622400000,
    "executedTime": null,
    "executedTxid": null,
    "forVotes": "0",
    "id": tempLength,
    "note": "",
    "proposalId": tempLength,
    "proposeTxid": "",
    "proposer": "",
    "queuedTime": null,
    "queuedTxid": null,
    "state": 2,
    "temp": true
}
export default class PoolStore {
    // for home nav start...
    @observable pagination = {
        pageNo: 1,
        orderBy: 'liquidity',
        desc: true,
        pageSize: 10
    };
    // @observable userData = {
    //   // 用户存款&借贷信息
    //   totalCount: 0,
    //   list: [],
    //   data: {}
    // };
    @observable userDataSource = null;
    @observable userDepositDataSource = null;
    @observable userLendDataSource = null;
    @observable userList = {}; // 用户数据
    @observable marketDataSource = [];
    @observable marketList = {}; // 时长数据
    @observable priceList = {};
    @observable trxPrice = '';
    @observable netAPY = '';
    @observable DAWPop = {
        // 存款/提现modal
        show: false,
        activeKey: '2',
        popData: {}
    };

    // 借贷限额
    @observable borrowLimit = '--';
    // 存款总额
    @observable totalBorrowUsd = '--';
    @observable mortgageModalInfo = {
        // 抵押/解押modal
        visible: false,
        type: 1, // 1 open, 2 close
        jtokenAddress: ''
    };
    @observable borrowModalInfo = {
        // 借款/还款modal
        visible: false,
        type: 1, // 1 借款, 2 还款
        jtokenAddress: ''
    };
    // 链上最新块信息
    @observable latestBlockInfo = null;

    // 当前块高
    @observable nowBlock = 0;

    @observable interval = null; // 每60秒获取链上最新块信息
    @observable backendInterval = null; // 每3秒轮询后端，轮询聚合合约获取余额和approve状态

    @observable balanceInfo = {}; // token余额和allowance信息
    @observable voteSourceList = [];
    @observable voteListLoading = true;
    @observable voteSourceData = null;
    @observable voteInfo = null;
    @observable voteForPop = false;
    @observable redeemFromVotePop = false;
    @observable exchangeVotePop = false;
    @observable authorizePop = false;
    @observable withdrawPop = false;
    @observable voteDetailData = null;
    @observable lockNum = BigNumber(0);
    @observable addVote = null;

    @observable openedModalFromSun = false;
    @observable marketDataSuccess = false;
    @observable tokenDataSuccess = false;
    @observable assetList = {}; // apy信息
    @observable usertronbullishData = null; // 用户参与的lend池挖矿收益
    @observable userCurrencyData = {}; // 用户参与的lend池挖矿收益 的 各个货币汇总
    @observable transferringSoon = '--'; // 用户即将发放汇总
    @observable inFreeze = '--'; // 用户冻结中总数
    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    setVariablesInterval = async () => {
        if (!this.interval) {
            await this.getLatestBlockInfo(); // 先取一次
            this.interval = setInterval(async () => {
                await this.getLatestBlockInfo();
                await this.getMintInfo();
            }, 60000);
        }

        if (!this.backendInterval) {
            this.backendInterval = setInterval(async () => {
                await this.getMarketData();
                await this.getUserData();
                if (this.rootStore.network.isConnected) {
                    await this.getTokenBalanceInfo();
                }
            }, 5000);
        }
    };

    clearVariablesInterval = () => {
        clearInterval(this.interval);
        clearInterval(this.backendInterval);
        this.interval = null;
        this.backendInterval = null;
    };

    filterEth = async (data = []) => {
        try {
            const res = await getTimeNow();
            if (res.success) {
                const start = res.time;
                if (data && start < Config.ethStartTime) {
                    data = data.filter(item => item.collateralSymbol != 'ETH');
                }
                return data;
            }
        } catch (error) {
            console.log('get time error', error);
        }
    };

    getTokenBalanceInfo = async () => {
        if (!this.rootStore.network.isConnected) return;
        const { marketDataSource } = this;
        const jtokens = [];
        const tokens = [];
        marketDataSource.map(item => {
            tokens.push(item.collateralAddress);
            jtokens.push(item.jtokenAddress);
        });
        await getBalanceInfo(window.defaultAccount, tokens, jtokens, this.balanceInfo);

        this.tokenDataSuccess = true;
        this.openWithdrawModal();
    };

    setMartketData = async (data = []) => {
        try {
            let obj = {};
            data = await this.filterEth(data);
            data.map(item => {
                item.key = item.jtokenAddress;
                item.balance = '--';
                item.precision = getPrecision(item.collateralDecimal); // done
                item.assetPrice = this.priceList[item.collateralAddress];
                item.depositApy = getDepositApy(item); // BigNumber(item.supplyratePerblock).div(Config.tokenDefaultPrecision).times(Config.blockPerYear);
                item.lendApy = getLendApy(item); //BigNumber(item.borrowratePerblock).div(Config.tokenDefaultPrecision).times(Config.blockPerYear);
                obj[item.jtokenAddress] = item;
            });
            this.marketDataSource = [...data];
            this.marketList = obj;
        } catch (err) {
            console.log('addJtokenValue:', err);
        }
    };

    getMarketData = async () => {
        try {
            // 获取市场信息
            const res = await getMarketData();
            if (!res.success) {
                return;
            }
            let marketData = res.data;
            this.priceList = marketData.assetPrice;
            this.trxPrice = marketData.trxPrice;
            this.setMartketData(marketData.jtokenList || []);

            this.marketDataSuccess = true;
            this.openWithdrawModal();
        } catch (err) {
            console.log('getMarketData', err);
        }
    };

    getMintInfo = async () => {
        try {
            // 获取挖矿信息
            const addr = this.rootStore.network.defaultAccount;
            const res = await getMintInfo(addr); // 单挖sun的版本
            if (!res.success) {
                return;
            }
            const { assetList } = res.data;
            // 世纪挖矿--获取多币种的综合APY
            if (!this.trxPrice) {
                await this.getMarketData();
            }
            const params = assetList.map(item => {
                const assetPrice = BigNumber(item.assetPrice);
                const totalOrigin = BigNumber(item.totalCash)
                    .plus(BigNumber(item.totalBorrow))
                    .minus(BigNumber(item.totalReserve));
                const totalTrx = totalOrigin.times(assetPrice).div(Config.tokenDefaultPrecision).div(Config.defaultPrecision);
                const totalUSD = totalTrx.times(this.trxPrice).div(Config.tokenDefaultPrecision);
                return { pool: item.jtokenAddress, tvl: BigNumber(totalUSD)._toFixed(2) };
            });
            const tvl = params.map(item => item.tvl).join(',');
            const pool = params.map(item => item.pool).join(',');
            const resNew = await getTronBull(pool, tvl);
            const poolBullAll = resNew.data || {};

            let obj = {};
            assetList.map(item => {
                const jtokenAddress = item.jtokenAddress;
                const totalSun = BigNumber(item.account_sunGainNew).div(Config.tokenDefaultPrecision);
                const gotSun = BigNumber(item.account_sunGainOld).div(Config.tokenDefaultPrecision); // 已发放
                const toBeGotSun = totalSun.minus(gotSun); // 未发放
                let totalAPYNEW = BigNumber(0); // 世纪挖矿APY

                const poolBull = poolBullAll[jtokenAddress] || {};
                Object.keys(poolBull).map(key => {
                    totalAPYNEW = totalAPYNEW.plus(poolBull[key]);
                });
                // console.log('key',totalAPYNEW.toString());
                obj[jtokenAddress] = {
                    apy: BigNumber(item.sunAPYInfo).times(100),
                    totalSun,
                    gotSun,
                    toBeGotSun,
                    totalAPYNEW: totalAPYNEW.times(100) // 仅仅只是大礼包挖矿的total
                };
            });
            // this.userDataSource = [...assetList];
            // console.log(this.userDataSource);
            this.assetList = obj;
        } catch (err) {
            console.log('getMintInfo', err);
        }
    };

    getLatestBlockInfo = async () => {
        const res = await getLatestBlockInfo();
        // 接口失败
        if (!res.success) {
            // 首次进入页面，数据为初始化状态不为null，直接用历史全局变量数据
            if (this.latestBlockInfo !== null) {
                return;
            }
            // 如果历史全局变量为null，使用缓存里面的数据
            if (!!window.localStorage.getItem('latestBlockInfo')) {
                // 如果接口没有获取到直接从本地缓存获取
                // console.log(JSON.parse(window.localStorage.getItem('latestBlockInfo')), 'window');
                this.latestBlockInfo = JSON.parse(window.localStorage.getItem('latestBlockInfo'));
                return;
            }
            // 都没有就直接return
            return;
        }
        this.latestBlockInfo = {
            number: res.number,
            timestamp: res.timestamp
        };
        window.localStorage.setItem(
            'latestBlockInfo',
            JSON.stringify({
                number: res.number,
                timestamp: res.timestamp
            })
        );
    };

    getCurrentBlock = async () => {
        try {
            if (this.latestBlockInfo === null) {
                await this.getLatestBlockInfo();
            }
            const { number = 0, timestamp = 0 } = this.latestBlockInfo || {};
            try {
                const res = await getTimeNow();
                if (res.success) {
                    const nowTime = res.time;
                    this.nowBlock = nowTime - timestamp <= 0 ? number : Math.floor((nowTime - timestamp) / 3000) + Number(number);
                    window.nowBlock = this.nowBlock;
                    return this.nowBlock;
                }
            } catch (err) {
                console.log('get time error', err);
            }
        } catch (err) {
            console.log('getCurrentBlock: ', err);
        }
    };

    getUserData = async () => {
        try {
            if (!this.rootStore.network.isConnected) return;
            let res = null;
            // 获取用户存款&借贷数据
            res = await getUserData({ addr: this.rootStore.network.defaultAccount });
            await this.getCurrentBlock();

            if (res === null || !res.success) return;
            this.trxPrice = BigNumber(res.data.trxPrice);
            // this.netAPY = res.data.netAPY; // 世纪挖矿版本改为前端结合挖矿数据做计算，不从后端取了
            this.setUserData(res.data.assetList || []);
            // console.log('getUserData  assetList', res.data.assetList);

            // 获取用户的挖矿收益，传的池子中多出了借款，后面处理中已过滤-------------- 0315:这里是一个bug，目前修复的传所有pools去获取用户的收益
            const addr = this.rootStore.network.defaultAccount;
            // console.log('res.data.assetList',res.data.assetList);
            let UserTronbullish = null;
            const params = Config.yielders.map(item => {
                return item.pool;
            });
            // console.log('params',params);

            // const params = res.data.assetList.map(item => {
            //   return item.jtokenAddress;
            // });
            const pool = params.join(',');
            UserTronbullish = await getTronbullish(pool, addr);
            if (UserTronbullish === null || !UserTronbullish.success) return;
            this.usertronbullishData = UserTronbullish.data;
            // console.log('this.usertronbullishData',this.usertronbullishData);
        } catch (err) {
            console.log('getUserData', err);
        }
    };

    setUserData = async (data = []) => {
        try {
            let obj = {};
            // 借贷限额
            this.borrowLimit = getBorrowLimit(this.trxPrice, data);
            data = await this.filterEth(data);
            // console.log(data, this.borrowLimit.toString(), '15666666666');
            data.map((item, index) => {
                const { collateralAddress, account_entered, jtokenAddress, collateralFactor } = item;
                item.key = jtokenAddress;
                // 质押开关状态
                item.account_entered = BigNumber(collateralFactor).eq(0) ? 2 : Number(account_entered);
                item.precision = getPrecision(item.collateralDecimal); // done
                item.depositApy = getDepositApy(item); // done
                item.exchangeRate = getExchangeRate(item); // done
                item.earned = getEarned(item); // done
                // 已存 token
                item.deposited = getDeposit(item); // done
                // 已存usd
                item.deposited_usd = getDepositUsd(item, this.trxPrice); // done
                item.lendApy = getLendApy(item); // done 借款apy
                // 借款token数量
                item.borrowBalanceNew = getBorrowBalanceNew(item);
                // 借款USD
                item.borrowBalanceNewUsd = getBorrowBalanceNewUsd(item, this.trxPrice);
                // 利息
                item.interest = getInterest(item);
                // 利息USD
                item.interestUsd = getInterestOrEarnedUsd(item, this.trxPrice);
                // 已赚USD
                item.earnedUsd = getInterestOrEarnedUsd(item, this.trxPrice, true);

                //借贷限额
                // item.borrowLimit = getBorrowLimit(item, this.trxPrice, data); // done
                // console.log(item.borrowLimit.toNumber(), '15666666666');
                // item.borrowLimitAfter = getBorrowLimitAfter(item, this.priceList, data);
                // console.log(item.borrowLimit, '1244444444444');

                //借款占比
                item.per = getBorrowPercent(item, this.trxPrice, this.borrowLimit);

                // 余额
                // item.balance = getBalance(this.balanceInfo);
                obj[item.jtokenAddress] = { ...item };
            });

            this.userDataSource = [...data];
            this.userList = obj;
            let lendData = data.filter(item => BigNumber(item.account_borrowBalance).gt(0));
            let depositData = data.filter(item => BigNumber(item.account_depositJtoken).gt(0));

            this.netAPY = getNetAPY(depositData, lendData, this.assetList);

            // 挖矿收益列表
            let currencyData = Config.currency;
            currencyData.map((item, index) => {
                const { gainOldAll, gainNewAll, price } = getGainNewAndOld(
                    this.assetList,
                    this.usertronbullishData,
                    item.symbol
                ); // depositData -> this.assetList
                //冻结中
                item.gainOld = gainOldAll;
                //即将发放
                item.gainNew = gainNewAll;
                item.price = price;
                currencyData[index] = { ...item };
                currencyData[index].key = index;
            });

            this.userCurrencyData = [...currencyData];
            this.totalBorrowUsd = getTotalLendUsd(lendData);
            const { transferringSoon, inFreeze } = getTransferringSoonAndInFreeze(currencyData);
            this.transferringSoon = transferringSoon;
            this.inFreeze = inFreeze;
            this.userLendDataSource = [...lendData];
            this.userDepositDataSource = [...depositData];
            // console.log('userDepositDataSource',this.userDepositDataSource);
        } catch (err) {
            console.log('addUserValue error:', err);
        }
    };

    getPramFromSun = () => {
        const type = getParameterByName('type');
        const tokenFromSun = getParameterByName('tokenAddress');
        if (tokenFromSun && type === 'withdraw') {
            this.setData({
                DAWPop: {
                    show: true,
                    activeKey: '2',
                    popData: this.userList[tokenFromSun] || this.marketList[tokenFromSun]
                },
                openedModalFromSun: true
            });
        }
    };

    getVoteBalanceOf = async token => {
        const address = this.rootStore.network.defaultAccount || Config.defaultAddress;
        // console.log(address);
        try {
            const { balance, allowance, success } = await tokenBalanceOf(token, address);
            if (success) {
                return allowance;
            }
        } catch (error) {
            console.log(`getTokenBalance error`, error);
        }
    };

    // 设置字段
    setData = (obj = {}, target = false) => {
        const self = this;
        Object.keys(obj).map(key => {
            if (target) {
                self[target][key] = obj[key];
            } else {
                self[key] = obj[key];
            }
        });
    };

    setList = (obj = {}, target, key) => {
        // console.log(obj, target, key, this[target][key]);
        // Object.keys(obj).map(_ => {
        //   this[target][key][_] = obj[_];
        // })
        Object.assign(this[target][key], obj);
    };

    showBorrowModal = (item, type) => {
        this.setData({ borrowModalInfo: { visible: true, jtokenAddress: item.jtokenAddress, type } });
    };

    hideBorrowModal = () => {
        this.setData({ borrowModalInfo: { visible: false, jtokenAddress: '', type: '1' } });
    };

    hideMortgageModal = () => {
        this.setData({ mortgageModalInfo: { visible: false, jtokenAddress: '', type: 1 } });
    };

    // 隐藏投票弹框
    hideVoteForPop = () => {
        this.setData({ voteForPop: false });
    };

    // 关闭兑换投票弹框
    hideExchangeVotePop = () => {
        this.setData({ exchangeVotePop: false });
    };

    // 关闭投票授权弹窗
    hideAuthorizePop = () => {
        this.setData({ authorizePop: false });
    };

    // 隐藏提现弹窗
    hideWithdrawPop = () => {
        this.setData({ withdrawPop: false });
    };

    hideDAWPop = () => {
        this.setData({
            DAWPop: {
                show: false,
                activeKey: '2',
                popData: null
            }
        });
    };

    // 获取所有投票方案
    getVoteList = async () => {

        this.setData({
            voteListLoading: true
        });
        let block = await this.getCurrentBlock();

        let list = await getVoteList(block).catch(e => {
            this.setData({
                voteSourceList: [],
                voteSourceData: {},
                voteListLoading: false
            });
        });
        let voteList = list?.proposalList || [];
        let obj = {},
            arr = [...voteList];
        voteList.map((item, index) => {
            if (item.state === 0) {
                item.intl = intl.get('trans_status.pending');
            } else if (item.state === 1) {
                item.intl = intl.get('vote.status_active');
            } else if (item.state === 2) {
                item.intl = intl.get('vote.status_canceld');
            } else if (item.state === 3) {
                //Defeated
                item.intl = intl.get('vote.status_failed');
            } else if (item.state === 4) {
                //Succeeded
                item.intl = intl.get('vote.status_passed');
            } else if (item.state === 5) {
                //Queued
                item.intl = intl.get('vote.status_passed');
                item.exIntl = intl.get('vote.status_queued');
            } else if (item.state === 6) {
                //Expired
                item.intl = intl.get('vote.status_passed');
                item.exIntl = intl.get('vote.status_expired');
            } else if (item.state === 7) {
                //Executed
                item.intl = intl.get('vote.status_passed');
                item.exIntl = intl.get('vote.status_executed');
            }
            if (item.state != -1) {
                obj[item.proposalId] = item;
            } else {
                arr.splice(index, 1);
            }
            if (item.proposalId) {
                item.title = intl.get(`proposal.proposal${item.proposalId}.title`)
            }
        });

        if (arr.length < tempLength) {
            tempProp.title = intl.get(`proposal.proposal${tempLength}.title`)
            tempProp.intl = intl.get('vote.status_comingsoon')
            arr.unshift(tempProp)
            obj[tempLength] = tempProp
        }
        this.setData({
            voteSourceList: arr,
            voteSourceData: obj,
            voteListLoading: false
        });
        let res = {
            arr,
            obj
        };
        return res;
    };

    // 获取JST等token余额 获取我的信息
    getBalanceForVote = async () => {
        const defaultAccount = this.rootStore.network.defaultAccount || Config.defaultAddress;
        let voteInfo = await this.rootStore.system.getVoteInfo(
            Config.contract.poly,
            defaultAccount,
            Config.contract.NFT,
            Config.contract.WNFTAddress
        );
        this.setData({
            voteInfo
        });
        // console.log(voteInfo);
    };

    // 获取所有投票方案
    getUserDetail = async proposalId => {
        let block = await this.getCurrentBlock();
        const address = this.rootStore.network.defaultAccount || Config.defaultAddress;
        let res = await getUserDetail(address, block);
        if (res.success) {
            let voteDetail = res.data.statusList.filter(item => Number(item.proposalId) === Number(proposalId))[0];
            if (voteDetail && BigNumber(voteDetail.forVotes).gt(0)) {
                this.setData({
                    addVote: 'yes'
                });
            } else if (BigNumber(voteDetail && voteDetail.againstVotes).gt(0)) {
                this.setData({
                    addVote: 'no'
                });
            } else {
                this.setData({
                    addVote: null
                });
            }
        } else {
            return null;
        }
    };

    // 提案详情
    getVoteDetail = async proposalId => {
        try {
            let res = await this.getVoteList();
            this.setData({
                voteDetailData: res.obj[proposalId]
            });
            this.getUserDetail(proposalId); // 获取所有投票方案, 判断用户支持/反对
            this.getUserVote(proposalId); // 用户所投具体方案的票数（合约）
            this.getBalanceForVote(); // 获取用户余额
        } catch (error) {
            console.log('getvoteDetail: ', error);
        }
    };

    // 用户所投
    getUserVote = async proposalId => {
        const { defaultAccount } = this.rootStore.network;
        const voteDetailData = this.voteDetailData;
        if (voteDetailData) {
            // 1: active 2: pending
            let vote = {
                userAddr: defaultAccount,
                proposalId,
                contractAddr: Config.contract.WNFTAddress
            };
            let lockNum = await this.rootStore.system.lockTo(vote);
            // console.log("lockNum:", lockNum);
            this.setData({
                lockNum
            });
        }
    };

    openWithdrawModal = () => {
        if (this.openedModalFromSun) return;
        if (this.tokenDataSuccess && this.marketDataSuccess) {
            this.getPramFromSun();
        }
    };
}
